module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_location_sola@2x-4c88f898b2e632299c46ccf0a38fc777.webp";